"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isApplicantAccountAnonymized = isApplicantAccountAnonymized;
function isApplicantAccountAnonymized(account) {
    if (!account) {
        return false;
    }
    return Boolean(account.anonymized);
}
